"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        let $sliders = $scope.find('.js-teaser-slider-lg');

        import('./slick.js').then(function() {
            $sliders.each(function() {

                let $slider = $(this);
                let $sliderWrapper = $slider.closest('.js-teaser-slider-lg__wrapper');

                $slider.slick({
                    dots: true, /*should always be true; hide with css (accessibility)*/
                    arrows:true,
                    slidesToShow: 1,
                    infinite:false,
                    variableWidth: true,
                    speed: 500,
                    cssEase: 'ease',
                    prevArrow: $sliderWrapper.find('.js-teaser-slider-lg__arrow-prev'),
                    nextArrow: $sliderWrapper.find('.js-teaser-slider-lg__arrow-next')
                });

            });
        })
    })
}